"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _get2 = _interopRequireDefault(require("lodash/fp/get"));

var _isServer = _interopRequireDefault(require("./isServer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Attempts to retrieve an environment variable from process.env 
function getEnvVar(varName) {
  // On the server, retrieve vars from process
  // eslint-disable-next-line no-undef
  if ((0, _isServer["default"])()) return (0, _get2["default"])("env.".concat(varName), process); // Otherwise, retrieve vars from window.process
  // eslint-disable-next-line no-undef

  return (0, _get2["default"])("process.env.".concat(varName), window);
}

var _default = getEnvVar;
exports["default"] = _default;